import React from 'react';
import { DuplicateMergeScreen } from './pages/DuplicateMergeScreen';
export function App() {
  return <DuplicateMergeScreen data-id="element-0" />;
}